let sentSeries = [];
let viewedSeries = [];
let downloadedSeries = [];

var createDaySlices = function (days, val) {
  days = days || 30;
  let ret = {};
  let i = days;
  let now = new Date();
  for (i; i > 0; i--) {
    let d = new Date();
    d.setDate(now.getDate() - i);
    let pad = Math.floor(d.getTime() / (1000 * 60 * 60 * 24));
    //  console.log(pad);
    let defaultVal = Object.assign({}, val);
    ret[pad] = defaultVal || 0;
  }
  return ret;
};

export const generateAttSessions = function (rawData) {
  let item,
    i = 0;
  let sessions = {};

  while ((item = rawData[i++])) {
    // console.log('debug generateSessions');
    // console.log(item);
    if (
      (item.objecttype === 'documentslideview' || item.objecttype === 'attachmentslideview') &&
      item.note.slidecount &&
      item.note.session &&
      !sessions[item.note.session + '-id']
    ) {
      let slidecount = parseInt(item.note.slidecount);
      // console.log(slidecount);
      let series = new Array(slidecount + 1).join('0').split('').map(parseFloat);
      sessions[item.note.session + '-id'] = {
        selected: true,
        msghashid: item.msghashid,
        slidecount: slidecount,
        recipient: item.recipient,
        location: item.note.location,
        ua: item.note.ua,
        isp: item.note.isp,
        ip: item.ip,
        series: series,
        utcts: item.utcts,
        note: item.note
      };
    }
  }

  i = 0;
  while ((item = rawData[i++])) {
    if (
      (item.objecttype === 'attachmentslideview' || item.objecttype === 'documentslideview') &&
      item.note.session &&
      sessions[item.note.session + '-id']
    ) {
      let slidenum = parseInt(item.note.slide) - 1;
      let ms = parseInt(item.note.ms);
      sessions[item.note.session + '-id'].series[slidenum] = ms;
    }
  }

  return sessions;
};

export const updateTimelineData = function (data) {
  const slices = createDaySlices(30, { sent: 0, viewed: 0, downloaded: 0 });
  let sentTotal = 0;
  let viewedTotal = 0;
  let downloadedTotal = 0;

  // console.log(data);
  data.forEach(function (item) {
    // console.log(`slices=${JSON.stringify(slices)}`);

    // console.log(`item.utcts=${item.utcts},${item.objecttype}`);
    let d = new Date(item.utcts);
    let dpad = Math.floor(d.getTime() / (1000 * 60 * 60 * 24));
    slices[dpad] = slices[dpad] || { sent: 0, viewed: 0, downloaded: 0 };
    // console.log(`dpad=${dpad}`);
    if (item.objecttype === 'attachment') {
      // console.log(item)
      slices[dpad].sent = slices[dpad].sent || 0;
      slices[dpad].sent++;
      sentTotal++;
    } else if (item.objecttype === 'attachmentview' || item.objecttype === 'documentview') {
      // console.log(item)
      slices[dpad].viewed = slices[dpad].viewed || 0;
      slices[dpad].viewed++;
      viewedTotal++;
    } else if (item.objecttype === 'attachmentdownload' || item.objecttype === 'attachmentdownload') {
      slices[dpad].downloaded = slices[dpad].downloaded || 0;
      slices[dpad].downloaded++;
      downloadedTotal++;
    }
  });

  sentSeries = [];
  viewedSeries = [];
  downloadedSeries = [];

  // console.log(`slices=${JSON.stringify(slices)}`);

  Object.keys(slices).forEach(function (k) {
    let ts = new Date(k * 1000 * 60 * 60 * 24).getTime();
    // console.log(`ts=${ts}`);
    sentSeries.push([ts, slices[k].sent]);
    viewedSeries.push([ts, slices[k].viewed]);
    downloadedSeries.push([ts, slices[k].downloaded]);
  });
  // console.log('SENT', sentSeries);
  // console.log('VIEWED', viewedSeries);
  // console.log('DOWNLOADED', downloadedSeries);

  return { sentSeries, viewedSeries, downloadedSeries, sentTotal, viewedTotal, downloadedTotal };
};
